import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Tag } from '../../../core';
export var TAG_WEB_CACHED = 'TAG_WEB_CACHED';
export var TagWebCached = /*#__PURE__*/function () {
  function TagWebCached() {
    _classCallCheck(this, TagWebCached);
  }

  _createClass(TagWebCached, [{
    key: "getTags",
    value: function () {
      var _getTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value, jsonTags, tags;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const value = sessionStorage?.getItem('tags');
                value = null;

                if (value) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", []);

              case 3:
                jsonTags = JSON.parse(value);
                tags = jsonTags.map(function (s) {
                  return Tag.create(s).getValue();
                });
                return _context.abrupt("return", tags);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getTags() {
        return _getTags.apply(this, arguments);
      }

      return getTags;
    }()
  }, {
    key: "saveTags",
    value: function () {
      var _saveTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tags) {
        var jsonTags, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jsonTags = tags.map(function (sub) {
                  return sub.toJsonObject();
                });
                value = JSON.stringify(jsonTags);
                localStorage.setItem('tags', value);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function saveTags(_x) {
        return _saveTags.apply(this, arguments);
      }

      return saveTags;
    }()
  }, {
    key: "deleteTags",
    value: function () {
      var _deleteTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                localStorage.removeItem('tags');

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function deleteTags() {
        return _deleteTags.apply(this, arguments);
      }

      return deleteTags;
    }()
  }]);

  return TagWebCached;
}();